import React, {useEffect, useMemo, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import EnhancedTable from "./tableComponent/EnhancedTable";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CssBaseline from "@material-ui/core/CssBaseline";
import InvoiciesService from "../../../services/InvoiciesService";

const Invoices = () => {

    const columns = useMemo(
        () => [
            {
                Header: 'Policy Holder',
                accessor: 'policyHolderName',
            },
            {
                Header: 'Company',
                accessor: 'companyName',
            },
            {
                Header: 'Invoicing Date',
                accessor: 'invoicingDate',
            },
            {
                Header: 'Due Date',
                accessor: 'dueDate',
            },
            {
                Header: 'Opening Balance',
                accessor: 'openingBalance',
            },
            {
                Header: 'Closing Balance',
                accessor: 'closingBalance',
            },
            {
                Header: 'Payment Received',
                accessor: 'paymentReceived'
            },
            {
                Header: 'Status',
                accessor: 'invoiceStatus'
            },
            {
                Header: 'Action',
                accessor: 'id',
                Cell: ({value}) => (
                    <span>
                        <Link className="btn btn-primary btn-sm "
                              onClick={() => viewInvoice(value)}>
                            View Clients <i className="fa fa-book"/>
                        </Link>
                    </span>
                )
            },
        ],
        []
    )

    //open clients
    const viewInvoice = (value) => {
        console.log(value);
        //store row record into localStorage
        localStorage.setItem('invoiceId', JSON.stringify(value));
        // props.history.push('/agent-clients');

    }
    const [data, setData] = useState([])
    const [skipPageReset, setSkipPageReset] = useState(false)

    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        InvoiciesService.getAllInvoices()
            .then(response => {
                console.log(response);
                setData(response.data.content);
            }).catch(err => {
            console.log(err);
        });

    }, []);

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard">
                                <a href> Dashboard </a>
                            </Link>
                             &nbsp;|&nbsp;
                            Invoices
                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <div className="content-panel">
                                    {/*    table of Sale army*/}
                                    <CssBaseline/>
                                    <EnhancedTable
                                        columns={columns}
                                        data={data}
                                        setData={setData}
                                        updateMyData={updateMyData}
                                        skipPageReset={skipPageReset}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Invoices;
